import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=de19e656&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=js&"
export * from "./CourseList.vue?vue&type=script&lang=js&"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=de19e656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de19e656",
  null
  
)

export default component.exports